import {
  OmsMarketplaceInternalNotesConditionStep,
  OmsOrderNotesConditionStep,
  OmsStreetAddressConditionStep,
} from "@redotech/redo-flows-common/oms/conditions";
import { OmsConditionStep } from "@redotech/redo-flows-common/steps";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { memo } from "react";
import { DeepPartial } from "..";

export const TextInput = memo(function TextInput({
  step,
  setStep,
}: {
  step:
    | DeepPartial<OmsStreetAddressConditionStep>
    | DeepPartial<OmsOrderNotesConditionStep>
    | DeepPartial<OmsMarketplaceInternalNotesConditionStep>;
  setStep: (step: DeepPartial<OmsConditionStep>) => void;
}) {
  return (
    <RedoTextInput
      setValue={(value) => setStep({ ...step, matchValue: value })}
      value={step.matchValue || ""}
    />
  );
});
